// extracted by mini-css-extract-plugin
var _1 = "cardSubText__qjgm7";
var _2 = "cardTextWrapper__itCXj";
var _3 = "contentWrapper__D1mSo";
var _4 = "section__TU5zc";
var _5 = "serviceTimeTextWrapper__Iuv7c";
var _6 = "title__K_wIH";
export { _1 as "cardSubText", _2 as "cardTextWrapper", _3 as "contentWrapper", _4 as "section", _5 as "serviceTimeTextWrapper", _6 as "title" }
export default { "cardSubText": _1, "cardTextWrapper": _2, "contentWrapper": _3, "section": _4, "serviceTimeTextWrapper": _5, "title": _6 }
